import styles from "./downloadsAntraege.module.css"
import { useNavigate } from "react-router-dom";
import TeamCard from "../../components/TeamCard/TeamCard";
import { Icons } from "../../../code/IconHandler";
import * as r from "../../../config/references_files";
function DownloadsAntraege() {
    const navigate = useNavigate();

    const abteilung = [
        {
            "team": "Sportangebot",
            "link": "/service/sportangebot",
            "img": Icons.SportOffer,
            "altText": 'Icon: Laufender Schuh'
        },
        {
            "team": "Terminkalender",
            "link": "/service/terminkalender",
            "img": Icons.Calender,
            "altText": 'Icon: Kalender'
        }
    ]
    return (
        <section className={styles.container}>
            <h1>Service</h1>
            <div className={styles.chapter}>

                <div className={styles.abteilungen}>
                    {abteilung.map((item, index) => (
                        <TeamCard key={index} item={item} />
                    ))}
                </div>
                <h2>Anträge</h2>
                <div className={styles.subchapter}>
                    <h3>TuS 05 - Verein</h3>
                    <ul>

                        <li id="kursabmeldung"><span onClick={() => navigate(r.kursabmeldung)}>Abmeldung: Kurs</span></li>
                        <li id="anmeldung-camp"><span onClick={() => navigate(r.anmeldungCamp)}>Anmeldung: Camp</span></li>
                        {/*
                        Rausgenommen am 17.08 
                        <li id="flexkarte-bestellen"><span onClick={() => navigate("/service/flexkarte-bestellen")}>Flexkarte bestellen</span></li>
                        */}
                        <li id="mitgliedsantrag-jugendfoerderverein"><span onClick={() => navigate(r.mitgliedantragJugendfoerderverein)}>Mitgliedsantrag des Jugendfördervereins</span></li>

                        <li id="mitgliedsantrag-tus"><span onClick={() => navigate(r.mitgliedantragTuS)}>Mitgliedsantrag des TuS 05 Oberpleis</span></li>
                        {/* <li id="sponsoring-engagement-tus"><span onClick={() => navigate("/service/sponsoring-engagement-tus")}>Sponsoring / Engagement beim TuS</span></li> */}
                    </ul>
                </div>
            </div>
            <section className={styles.chapter}>
                <h2>Downloads</h2>
                <section className={styles.subchapter}>
                    <h3>OGS</h3>
                    <ul>
                        <li id="betreuungsvertrag">
                            <a href={r.ogs_betreuung} target="_blank" rel="noopener noreferrer">Betreuungsvertrag</a>
                        </li>
                        <li id="satzung-stadt-koenigswinter"><a href={r.elternbeitragtagesbetreuung} target="_blank" rel="noopener noreferrer">Satzung der Stadt Königswinter über die Erhebung von Elternbeiträgen für die Tagesbetreuung von Kindern inkl. Beitragstabelle</a></li>
                    </ul>
                </section>
                <section className={styles.subchapter}>
                    <h3>OGS - Stellenausschreibung</h3>
                    <ul>
                        <li id="ogs-betreuung"><a href={r.stellenanzeige} target="_blank" rel="noopener noreferrer">Betreuungskraft: Stellenanzeige OGS Oberpleis</a></li>
                    </ul>
                </section>
                <section className={styles.subchapter}>
                    <h3>TuS 05 - Verein</h3>
                    <ul>
                        <li id="erklaerung-zu-spenden"><a href={r.spendenErklaerung} target="_blank" rel="noopener noreferrer">Erklärung zu Spenden</a></li>
                        <li id="jugenschutzkonzept"><a href={r.jugendschutzkonzept} target="_blank" rel="noopener noreferrer">Jugendschutzkonzept (2024)</a></li>

                        {/* <li id="leitbild-des-tus-05-oberpleis"><a href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/BeispielPDF.pdf`} target="_blank" rel="noopener noreferrer">Leitbild des TuS 05 Oberpleis</a></li> */}
                        <li id="protokoll-mitgliederversammlung-20240618"><a href={r.mitgliederversammlung2024} target="_blank" rel="noopener noreferrer">Protokoll zur Mitgliederversammlung 18.06.2024</a></li>
                        <li id="protokoll-mitgliederversammlung-20230613"><a href={r.mitgliederversammlung2023} target="_blank" rel="noopener noreferrer">Protokoll zur Mitgliederversammlung 13.06.2023</a></li>
                        <li id="protokoll-mitgliederversammlung-20220621"><a href={r.mitgliederversammlung2022} target="_blank" rel="noopener noreferrer">Protokoll zur Mitgliederversammlung 21.06.2022</a></li>
                        <li id="protokoll-mitgliederversammlung-20210929"><a href={r.mitgliederversammlung2021} target="_blank" rel="noopener noreferrer">Protokoll zur Mitgliederversammlung 28.09.2021</a></li>
                        <li id="satzung-beschluss-20200928"><a href={r.satzung2020} target="_blank" rel="noopener noreferrer">Satzung: Beschluss Mitgliederversammlung vom 28.09.2020</a></li>
                    </ul>
                </section>
                {/* <section className={styles.subchapter}>
                    <h3>TuS 05 - Stellenausschreibungen</h3>
                    <ul>
                        <li id="fsj"><a href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/BeispielPDF.pdf`} target="_blank" rel="noopener noreferrer">Stellenausschreibung: FSJ</a></li>
                        <li id="uebungsleiter"><a href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/BeispielPDF.pdf`} target="_blank" rel="noopener noreferrer">Stellenausschreibung: Übungsleiter:in</a></li>
                    </ul>
                </section> */}
                <section className={styles.subchapter}>
                    <h3>TuS 05 - Fördervereine</h3>
                    <ul>
                        {/* <li id="aufnahmeantrag-jugendfoerderverein-fußball"><a href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/aufnahmeantrag_foerderer_jugendfussball.pdf`} target="_blank" rel="noopener noreferrer">Annahmevertrag Jugendförderverein (Fußball)</a></li> */}
                        <li id="aufnahmeantrag-freunde-und-foerderer-fußball"><a href={r.aufnahmeAntragFreundeFoerderer} target="_blank" rel="noopener noreferrer">Mitgliederantrag Freunde und Förderer (Fußball)</a></li>
                        <li id="satzung-jugendfoerderverein"><a href={r.satzungJugendfoerderverein} target="_blank" rel="noopener noreferrer">Satzung Jugendförderverein</a></li>
                    </ul>
                </section>
                <section className={styles.subchapter}>
                    <h3>TuS 05 - Fußball</h3>
                    <ul>
                        <li id="passantrag-westdeutscher-fußballverein-ev"><a href={r.passantragWestdeutscherFussball} target="_blank" rel="noopener noreferrer">Passantrag WESTDEUTSCHER FUßBALLVEREIN E.V.</a></li>
                    </ul>
                </section>
            </section>
        </section>
    )
}

export default DownloadsAntraege;